import React, { Component } from 'react';
import { connect } from 'react-redux';
import { BloxButton } from 'styled_components/Common/BloxButton';
import { Utils } from 'services/utils';
import { UserApi, deleteUserProfile } from 'services/user';
import { EulaBody } from 'styled_components/Common/EulaBody';
import { CompanyProfileApi } from 'services/companyProfile';
import { logoutUser } from 'actions/auth';
import { RESOLUTIONS } from 'services/config';
import { PortraitModalComponent } from 'styled_components/Common/PortraitModalComponent';
import { ModalFooter } from 'styled_components/Common/ModalFooter';
import { getAuthenticatedUser } from 'actions/auth';

const CDN_URL = process.env.REACT_APP_CDN_URL;

class EulaModal extends Component {
	constructor(props) {
		super(props);
		this.companyApi = new CompanyProfileApi();
		this.state = {
			showModal: false,
			title: 'Please read and accept our EULA to continue using our site.',
			eula: null,
			enabled: false,
			version: null,
			buttonActive: false,
		};
	}

	componentDidMount() {
		const {
			auth: { eulaUserDetails },
		} = this.props;
		this.getEulaLatestVersion();
		if (eulaUserDetails?.status !== 'accepted') {
			this.setState({ showModal: true });
		}
	}
	getEulaLatestVersion = () => {
		UserApi.getEulaVersion()
			.then(response => {
				const validResponse = response.status === 200 && response.data;
				if (validResponse) {
					this.setState({ version: response.data?.version });
				}
				this.getCurrentEula(response.data?.version);
			})
			.catch(error => {
				console.log(error);
			});
	};
	getCurrentEula = version => {
		let url = CDN_URL.split('cdn');

		const versionToUse = version ? version : '1.0';
		url = url[0];
		url = `${url}cdn/eula/eula-${versionToUse}.html`;
		UserApi.getEula(url)
			.then(response => {
				const validResponse = response.status === 200 && response.data;
				if (validResponse) {
					this.setState({ eula: response.data });
				}
			})
			.catch(() => {});
	};

	toggleModal = () => {
		const { showModal } = this.state;
		this.setState({ showModal: !showModal });
	};

	updateStatus = async status => {
		const { startTour } = this.props;

		const {
			site,
			auth: { user },
			getAuthenticatedUser,
		} = this.props;

		const { version } = this.state;
		const browserInfo = await Utils.getClientParams(site);
		const versionToUse = version ? version : '1.0';

		const params = {
			user_id: user?.id,
			eula_id: 1,
			status,
			version: versionToUse,
			browserInfo,
		};

		UserApi.updateEulaStatus(params)
			.then(response => {
				const validResponse = response.status === 200 && response.data && response.data.updated;
				if (validResponse) {
					if (status === 'accepted') {
						deleteUserProfile();
						getAuthenticatedUser();

						startTour();

						this.toggleModal();
					}
				}
			})
			.catch(error => {
				console.log(error);
			});
	};
	rejectEula = () => {
		const { logoutUser } = this.props;
		this.updateStatus('rejected');
		//logout user
		logoutUser();
	};
	setInfoModal = () => {
		const { setModalContent } = this.props;
		const headerText = 'To continue using our site you must accept our EULA agreement.';
		const button = (
			<BloxButton
				className='buttons41'
				id='okay'
				text='LOGOUT'
				module='account'
				enabled={true}
				onClick={this.rejectEula}
				cypressId='continue-logout'
			/>
		);
		setModalContent(false, headerText, button);
	};
	getSize = breakpoint => {
		let size = 'large';
		if (breakpoint === RESOLUTIONS.MED) {
			size = 'medium';
		} else if (breakpoint === RESOLUTIONS.HIGH) {
			size = 'medium';
		}

		return size;
	};
	hasReachedBottom = atBottom => {
		if (atBottom) {
			this.setState({ buttonActive: true });
		}
	};
	renderHeader() {
		return (
			<div className='default-header'>
				<div className='heading60'>
					Please read and accept our EULA to continue using our site.{' '}
				</div>
			</div>
		);
	}

	render() {
		const { showModal, title, eula, buttonActive, version } = this.state;
		const { breakpoint } = this.props;

		return (
			<div id='eula-banner-container' className='eula-banner-container'>
				<PortraitModalComponent
					closeModal={this.setInfoModal}
					show={showModal}
					header={this.renderHeader(title)}
					title='EULA AGREEMENT'
					subTitle={`EULA - Version: ${version}`}
					size={this.getSize(breakpoint)}
					breakpoint={breakpoint}
				>
					<EulaBody eula={eula} hasReachedBottom={this.hasReachedBottom} />
					<ModalFooter
						cypressId='footer'
						id='footer'
						buttonText1='Accept'
						buttonActive1={buttonActive}
						module='account'
						buttonFunction1={() => this.updateStatus('accepted')}
						size={this.getSize(breakpoint)}
						message={'Please scroll all the way to the bottom to activate the button.'}
						//buttonFunction2={() => {}}
					/>
				</PortraitModalComponent>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		site: state.site_tracking,
		auth_status: state.auth_status,
		company_info: state.company_info,
	};
}

export default connect(mapStateToProps, { logoutUser, getAuthenticatedUser })(EulaModal);
